import { fetchJson } from 'lib/common/fetcher';
import find from 'lodash/fp/find';
import flow from 'lodash/fp/flow';
import get from 'lodash/fp/get';
import toInteger from 'lodash/toInteger';

export default function fetchSeatViews(endpoint, currentFacility) {
  if (!currentFacility) {
    return Promise.resolve(false);
  }

  return fetchJson(endpoint).then(function(response) {
    return flow(
      get('facilities'),
      find(x => toInteger(x.facility_no) === currentFacility.facility_no),
      get('seat_images')
    )(response);
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/seats/fetchSeatViews.js